var map = {
	"./cezanne.png": 1807,
	"./daVinci.png": 847,
	"./dali.png": 7701,
	"./durer.png": 2595,
	"./fengzikai.png": 1042,
	"./ghibli.png": 7070,
	"./ingres.png": 1215,
	"./matisse.png": 1247,
	"./mondrian.png": 2470,
	"./monet.png": 5968,
	"./mucha.png": 6003,
	"./none.png": 4970,
	"./picasso.png": 2591,
	"./rembrandt.png": 8854,
	"./van-gogh.png": 7219,
	"./vermeer.png": 2600,
	"./wuguanzhong.png": 175,
	"./zhangdaqian.png": 5179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9209;